import { RouteConfig } from "vue-router";
import ResearchComponent from "@/views/research/research.vue";

export const RESEARCH_ROUTES: RouteConfig[] = [
  {
    path: "/research",
    name: "ResearchComponent",
    component: ResearchComponent,
    meta: {
      requiresAuth: true
    }
  }
];